import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, useHistory, useLocation } from 'react-router-dom'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
// import theme from '../../theme'
import { createTheme } from '../../theme/index'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { es } from 'date-fns/locale'

import LandingThemeProvider from '../Landings/theme'

import SuspenseLoader from './SuspenseLoader'
import { CssBaseline } from '@mui/material'
import ErrorBoundary from '../Utils/ErrorBoundary.tsx'
import FloatingWhatsApp from '../LaitenLanding/components/FloatingWhatsApp'
import ClarityInit from '../LaitenLanding/components/ClarityInit'

const AccessConnectLanding = React.lazy(() => delayForDemo(import('../Landings/sections/_access_connect/view/MarketingLandingView')))
const MembershipConnectLanding = React.lazy(() => delayForDemo(import('../Landings/sections/_membership_connect/view/MarketingLandingView')))
const PropertyConnectLanding = React.lazy(() => delayForDemo(import('../Landing/Landing')))
const LaitenLanding = React.lazy(() => delayForDemo(import('../LaitenLanding/Landing')))
const Demo = React.lazy(() => delayForDemo(import('../LaitenLanding/Demo/Demo')))
const ModernDemo = React.lazy(() => delayForDemo(import('../LaitenLanding/Demo/ModernDemo')))
const FAQ = React.lazy(() => delayForDemo(import('../LaitenLanding/Faq/ModernFaq')))
const ResidentialLanding = React.lazy(() => delayForDemo(import('../LaitenLanding/Solutions/ResidentialLanding')))
const FitnessLanding = React.lazy(() => delayForDemo(import('../LaitenLanding/Solutions/FitnessLanding')))
const CoworkingLanding = React.lazy(() => delayForDemo(import('../LaitenLanding/Solutions/CoworkingLanding')))
const AcademiasLanding = React.lazy(() => delayForDemo(import('../LaitenLanding/Solutions/AcademiasLanding')))
const BellezaLanding = React.lazy(() => delayForDemo(import('../LaitenLanding/Solutions/BellezaLanding')))
const AccessControlLanding = React.lazy(() => delayForDemo(import('../LaitenLanding/AccessControl/Landing/AccessControlLanding')))
const AdministrationControlLanding = React.lazy(() => delayForDemo(import('../LaitenLanding/Administration/Landing/AdministrationControlLanding')))
const App = React.lazy(() => delayForDemo(import('../App/App')))
const ModernCaracteristicas = React.lazy(() => delayForDemo(import('../LaitenLanding/Caracteristicas/ModernCaracteristicas')))
const FiscalPrivacy = React.lazy(() => delayForDemo(import('../Privacy/FiscalPrivacy')))
const BiometricPrivacy = React.lazy(() => delayForDemo(import('../Privacy/BiometricPrivacy')))
const HealthPrivacy = React.lazy(() => delayForDemo(import('../Privacy/HealthPrivacy')))
const Privacy = React.lazy(() => delayForDemo(import('../Privacy/Privacy')))
const Terms = React.lazy(() => delayForDemo(import('../Terms/Terms')))

function delayForDemo(promise) {
  return new Promise(resolve => {
    setTimeout(resolve, 2)
  }).then(() => promise)
}

const AppFileProxy = props => {
  const location = useLocation()
  const history = useHistory()

  const theme = createTheme({
    colorPreset: 'laiten',
    contrast: 'high',
    direction: 'ltr',
    layout: 'vertical',
    navColor: 'evident',
    paletteMode: 'light',
    responsiveFontSizes: true,
    stretch: false,
  })

  const AccessConnectLandingWithTheme = () => {
    return (
      <Suspense fallback={<SuspenseLoader />}>
        <LandingThemeProvider>
          <AccessConnectLanding />
        </LandingThemeProvider>
      </Suspense>
    )
  }

  const MembershipConnectWithTheme = () => {
    return (
      <Suspense fallback={<SuspenseLoader />}>
        <LandingThemeProvider>
          <MembershipConnectLanding />
        </LandingThemeProvider>
      </Suspense>
    )
  }

  const PropertyConnectLandingWithTheme = () => {
    return (
      <Suspense fallback={<SuspenseLoader />}>
        <ErrorBoundary>
          <LandingThemeProvider>
            <PropertyConnectLanding />
          </LandingThemeProvider>
        </ErrorBoundary>
      </Suspense>
    )
  }

  const LaitenLandingWithTheme = () => {
    return (
      <Suspense fallback={<SuspenseLoader />}>
        <ErrorBoundary>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                <CssBaseline />
                <Switch>
                  <Route exact path='/' component={LaitenLanding} />
                  <Route exact path='/laiten' component={LaitenLanding} />
                  <Route exact path='/laiten/demo' component={Demo} />
                  <Route exact path='/demo' component={ModernDemo} />
                  <Route exact path='/laiten/faq' component={FAQ} />
                  <Route exact path='/laiten/caracteristicas' component={ModernCaracteristicas} />
                  <Route exact path='/laiten/soluciones/residenciales' component={ResidentialLanding} />
                  <Route exact path='/laiten/soluciones/fitness' component={FitnessLanding} />
                  <Route exact path='/laiten/soluciones/coworking' component={CoworkingLanding} />
                  <Route exact path='/laiten/soluciones/academias' component={AcademiasLanding} />
                  <Route exact path='/laiten/soluciones/belleza' component={BellezaLanding} />
                  <Route exact path='/laiten/control-de-accesos' component={AccessControlLanding} />
                  <Route exact path='/laiten/administracion' component={AdministrationControlLanding} />
                  <Route exact path='/fiscal-politica-de-privacidad' component={FiscalPrivacy} />
                  {/* Las mismas rutas que usa la app; las de abajo se quedan por links viejos */}
                  <Route exact path='/aviso-privacidad-biometricos' component={BiometricPrivacy} />
                  <Route exact path='/aviso-privacidad-salud' component={HealthPrivacy} />
                  <Route exact path='/biometricos-politica-de-privacidad' component={BiometricPrivacy} />
                  <Route exact path='/salud-politica-de-privacidad' component={HealthPrivacy} />
                  <Route exact path='/politica-de-privacidad' component={Privacy} />
                  <Route exact path='/terminos-y-condiciones' component={Terms} />
                </Switch>
                <ClarityInit />
                <FloatingWhatsApp />
              </LocalizationProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </ErrorBoundary>
      </Suspense>
    )
  }

  const type = 'laiten'
  const landings = {
    accessConnect: {
      link: '/access-connect',
      component: <AccessConnectLandingWithTheme />,
      key: 'accessConnect'
    },
    membershipConnect: {
      link: '/membership-connect',
      component: <MembershipConnectWithTheme />,
      key: 'membershipConnect'
    },
    propertyConnect: {
      link: '/property-connect',
      key: 'propertyConnect',
      component: <PropertyConnectLandingWithTheme />
    },
    laiten: {
      link: '/laiten',
      key: 'laiten',
      component: <LaitenLandingWithTheme />
    }
  }

  if (location.pathname === landings.accessConnect.link) {
    return landings.accessConnect.component
  }

  if (location.pathname === landings.membershipConnect.link) {
    return landings.membershipConnect.component
  }

  if (location.pathname === landings.propertyConnect.link) {
    return landings.propertyConnect.component
  }

  if (location.pathname.includes(landings.laiten.link)) {
    return landings.laiten.component
  }

  if (location.pathname === '/fiscal-politica-de-privacidad') {
    return landings.laiten.component
  }

  if (['/aviso-privacidad-biometricos', '/biometricos-politica-de-privacidad'].includes(location.pathname)) {
    return landings.laiten.component
  }

  if (['/aviso-privacidad-salud', '/salud-politica-de-privacidad'].includes(location.pathname)) {
    return landings.laiten.component
  }

  if (location.pathname === '/politica-de-privacidad') {
    return landings.laiten.component
  }

  if (location.pathname === '/terminos-y-condiciones') {
    return landings.laiten.component
  }

  if (location.pathname === '/') {
    switch (type) {
      case landings.accessConnect.key:
        return landings.accessConnect.component
      case landings.membershipConnect.key:
        return landings.membershipConnect.component
      case landings.propertyConnect.key:
        return landings.propertyConnect.component
      case landings.laiten.key:
        return landings.laiten.component
      case 'none':
        history.push('/inicio')
        return <></>
    }
  }
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <ErrorBoundary>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
              <App />
            </LocalizationProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </ErrorBoundary>
    </Suspense>
  )
}

AppFileProxy.propTypes = {}

export default AppFileProxy
